import React from "react";
import cs from "classnames";
import Swipe from "react-easy-swipe";
import { useSwipeable, Swipeable } from "react-swipeable";
import danielle from "./assets/farmer-full.png";
import "./App.css";

const directionStyle = {
  marginBottom: "5px",
  marginTop: "5px"
};

const TICK_RATE = 100;
const GRID_SIZE = 20;
const GRID = [];
let interval = null;

for (let i = 0; i <= GRID_SIZE; i++) {
  GRID.push(i);
}

const DIRECTIONS = {
  UP: "UP",
  BOTTOM: "BOTTOM",
  RIGHT: "RIGHT",
  LEFT: "LEFT",
  ESCAPE: "ESCAPE",
  RESET: "RESET"
};

const DIRECTION_TICKS = {
  UP: (x, y) => ({ x, y: y - 1 }),
  BOTTOM: (x, y) => ({ x, y: y + 1 }),
  RIGHT: (x, y) => ({ x: x + 1, y }),
  LEFT: (x, y) => ({ x: x - 1, y })
};

const KEY_CODES_MAPPER = {
  27: "ESCAPE",
  32: "RESET",
  38: "UP",
  39: "RIGHT",
  37: "LEFT",
  40: "BOTTOM"
};

const getRandomNumberFromRange = (min, max) =>
  Math.floor(Math.random() * (max - min + 1) + min);

const getRandomCoordinate = () => ({
  x: getRandomNumberFromRange(1, GRID_SIZE - 1),
  y: getRandomNumberFromRange(1, GRID_SIZE - 1)
});

const isBorder = (x, y) =>
  x === 0 || y === 0 || x === GRID_SIZE || y === GRID_SIZE;

const isPosition = (x, y, diffX, diffY) => x === diffX && y === diffY;

const isSnake = (x, y, snakeCoordinates) =>
  snakeCoordinates.filter(coordinate =>
    isPosition(coordinate.x, coordinate.y, x, y)
  ).length;

const getSnakeHead = snake => snake.coordinates[0];

const isSnakeHead = (x, y, snake) => {
  if (snake.coordinates[0].x === x && snake.coordinates[0].y === y) {
    return true;
  }
  return false;
};

const getSnakeWithoutStub = snake =>
  snake.coordinates.slice(0, snake.coordinates.length - 1);

const getSnakeTail = snake => snake.coordinates.slice(1);

const getIsSnakeOutside = snake =>
  getSnakeHead(snake).x >= GRID_SIZE ||
  getSnakeHead(snake).y >= GRID_SIZE ||
  getSnakeHead(snake).x <= 0 ||
  getSnakeHead(snake).y <= 0;

const getIsSnakeClumy = snake => {
  return isSnake(
    getSnakeHead(snake).x,
    getSnakeHead(snake).y,
    getSnakeTail(snake)
  );
};

const getScore = (state, bool) => {
  let score = state.playground.score;
  if (bool) {
    return score + 1;
  }
  return score;
};

const backwards = (request, current) => {
  if (current === "LEFT" && request === "RIGHT") {
    return true;
  }
  if (current === "RIGHT" && request === "LEFT") {
    return true;
  }
  if (current === "UP" && request === "BOTTOM") {
    return true;
  }
  if (current === "BOTTOM" && request === "UP") {
    return true;
  }
  return false;
};

const getIsSnakeEating = ({ snake, snack }) => {
  return isPosition(
    getSnakeHead(snake).x,
    getSnakeHead(snake).y,
    snack.coordinate.x,
    snack.coordinate.y
  );
};

const getCellCs = (isGameOver, snake, snack, x, y, isGameStopped) => {
  return cs("grid-cell", {
    "grid-cell-stopped": isGameOver || isGameStopped,
    "grid-cell-border": isBorder(x, y),
    "grid-cell-snake":
      !isSnakeHead(x, y, snake) && isSnake(x, y, snake.coordinates),
    "grid-cell-head": isSnakeHead(x, y, snake),
    "grid-cell-snack": isPosition(x, y, snack.coordinate.x, snack.coordinate.y),
    "grid-cell-hit":
      isGameOver &&
      isPosition(x, y, getSnakeHead(snake).x, getSnakeHead(snake).y)
  });
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SNAKE_CHANGE_DIRECTION":
      // console.log(state.playground.isGameOver);
      if (!state.playground.isGameOver) {
        // console.log("Game is not over");
        if (state.playground.score > 0) {
          if (!backwards(action.direction, state.playground.direction)) {
            return {
              ...state,
              playground: {
                ...state.playground,
                direction: action.direction
              }
            };
          }
        } else {
          return {
            ...state,
            playground: {
              ...state.playground,
              isGamePaused: false,
              direction: action.direction
            }
          };
        }
      }

    case "SNAKE_MOVE":
      if (!state.playground.isGameOver) {
        const isSnakeEating = getIsSnakeEating(state);

        const score = getScore(state, isSnakeEating);

        // console.log(score);

        const snakeHead = DIRECTION_TICKS[state.playground.direction](
          getSnakeHead(state.snake).x,
          getSnakeHead(state.snake).y
        );

        const snakeTail = isSnakeEating
          ? state.snake.coordinates
          : getSnakeWithoutStub(state.snake);

        const snackCoordinate = isSnakeEating
          ? getRandomCoordinate()
          : state.snack.coordinate;

        return {
          ...state,
          playground: {
            ...state.playground,
            isGamePaused: false,
            score
          },
          snake: {
            coordinates: [snakeHead, ...snakeTail]
          },
          snack: {
            coordinate: snackCoordinate
          }
        };
      }
    case "GAME_OVER":
      // clearInterval(interval);
      // console.log(scores);
      console.log(action.highscore);
      return {
        ...state,
        playground: {
          ...state.playground,
          isGameOver: true,
          showScores: action.highscore,
          highScore: action.highscore
        }
      };

    case "RESET_GAME":
      console.log('reset game');
      if (!state.playground.showScores) {
        console.log('resetting game');
        return {
          ...initialState,
          snake: {
            coordinates: [getRandomCoordinate()]
          },
          snack: {
            coordinate: getRandomCoordinate()
          }
        };
      } else {
        return {...state};
      } 
      
    case "SCORE_SUBMITTED":
      console.log('score sub');
      return {
        ...state,
        playground: {
          ...state.playground,
          highScore: false
        }
      };

    case "SHOW_SCORES":
      return {
        ...state,
        playground: {
          ...state.playground,
          showScores: true
        }
      };
    case "CLOSE_SCORES":
      return {
        ...state,
        playground: {
          ...state.playground,
          showScores: false
        }
      };
    case "PAUSE_GAME":
      return {
        ...state,
        playground: {
          ...state.playground,
          isGamePaused: !state.playground.isGamePaused
        }
      };
    default:
      throw new Error();
  }
};

const initialState = {
  playground: {
    direction: DIRECTIONS.RIGHT,
    isGameOver: false,
    isGamePaused: true,
    score: 0,
    showScores: false,
    highScore: false
  },
  snake: {
    coordinates: [getRandomCoordinate()]
  },
  snack: {
    coordinate: getRandomCoordinate()
  }
};

// const isGamePaused = state => {
//   return state.playground.isGamePaused;
// };

// const isGameOver = state => {
//   return state.playground.isGameOver;
// };

// function useOutsideAlerter(ref) {
//   /**
//    * Alert if clicked on outside of element
//    */
//   function handleClickOutside(event) {
//     // console.log(ref.current);
//     if (ref.current && !ref.current.contains(event.target)) {
//       // alert("You clicked outside of me!");
//       dispatch({
//         type: "CLOSE_SCORES"
//       });
//     }
//   }

//   React.useEffect(() => {
//     // Bind the event listener
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       // Unbind the event listener on clean up
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   });
// }

const App = () => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const [scores, setScores] = React.useState([]);

  const [name, setName] = React.useState("");
  const reset = () => {
    dispatch({
      type: "RESET_GAME"
    });
    dispatch({
      type: "RESET_GAME"
    });
  };

  const pause = () => {
    dispatch({
      type: "PAUSE_GAME"
    });
  };

  const onChangeDirection = event => {
    if (KEY_CODES_MAPPER[event.keyCode] === "ESCAPE") {
      dispatch({
        type: "PAUSE_GAME"
      });
    } else if (KEY_CODES_MAPPER[event.keyCode] === "RESET") {
      dispatch({
        type: "RESET_GAME"
      });
      // dispatch({
      //   type: "RESET_GAME"
      // });
    } else {
      if (KEY_CODES_MAPPER[event.keyCode]) {
        dispatch({
          type: "SNAKE_CHANGE_DIRECTION",
          direction: KEY_CODES_MAPPER[event.keyCode]
        });
      }
    }
  };

  React.useEffect(() => {
    window.addEventListener("keyup", onChangeDirection, false);
    // document.addEventListener("mousedown", handleClickOutside);

    getScores();

    return () => {
      window.removeEventListener("keyup", onChangeDirection, false);
      // document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  React.useEffect(
    () => {
      const onTick = () => {
        if (!state.playground.isGamePaused) {
          getIsSnakeOutside(state.snake) || getIsSnakeClumy(state.snake)
            ? gameOver()
            : dispatch({ type: "SNAKE_MOVE" });
        }
      };

      interval = setInterval(onTick, TICK_RATE);

      return () => {
        clearInterval(interval);
      };
    },
    [state]
  );

  const gameOver = () => {
    if (!state.playground.isGameOver) {
      if (scores.length < 5) {
        dispatch({ type: "GAME_OVER", highscore: true });
      } else {
        let nScore = scores.slice(0, 5);
        let newHighScore = nScore.some(function(val) {
          return val.score < state.playground.score;
        });
        if (newHighScore) {
          // if (state.playground.score > x.score) {
          dispatch({ type: "GAME_OVER", highscore: true });
          // }
        } else {
          dispatch({ type: "GAME_OVER", highscore: false });
        }
        // scores.map((x, i) => {
        //   if (i < 5) {
        //     console.log(state.playground.score + " : " + x.score);

        //   }
        // });
      }
    }
  };

  const getScores = () => {
    const myHeaders = new Headers();
    fetch("https://www.jsausa.com/arcade/api/hiscore/farmer", {
      method: "GET",
      headers: myHeaders
    })
      .then(response => response.json())
      .then(json => {
        console.log(json);
        setScores(json.result);
        if (json.result.length === 0) {
          console.log("No Scores Yet!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  // const handleClickOutside = (e) => {
  //   console.log(e.target);
  //   console.log(ref.node);
  //   // if (ref.current && !ref.current.contains(event.target))
  //   if(this.node && this.node.contains(e.target)) {
  //     return;
  //   }
  //   dispatch({
  //     type: "CLOSE_SCORES"
  //   });
  // }

  const onSwipeUp = () => {
    console.log("up");
    dispatch({
      type: "SNAKE_CHANGE_DIRECTION",
      direction: "UP"
    });
  };

  const onSwipeDown = () => {
    console.log("down");
    dispatch({
      type: "SNAKE_CHANGE_DIRECTION",
      direction: "BOTTOM"
    });
  };

  const onSwipeLeft = () => {
    console.log("left");
    dispatch({
      type: "SNAKE_CHANGE_DIRECTION",
      direction: "LEFT"
    });
  };

  const onSwipeRight = () => {
    console.log("right");
    dispatch({
      type: "SNAKE_CHANGE_DIRECTION",
      direction: "RIGHT"
    });
  };

  const openScores = () => {
    const myHeaders = new Headers();
    fetch("https://www.jsausa.com/arcade/api/hiscore/farmer", {
      method: "GET",
      headers: myHeaders
    })
      .then(response => response.json())
      .then(json => {
        // console.log(json);
        setScores(json.result);
        // if (json.result.length === 0) {
        // console.log("No Scores Yet!");
        // }
      })
      .catch(err => {
        console.log(err);
      });
    // console.log(state);
    dispatch({
      type: "SHOW_SCORES"
    });
  };

  const submitScore = () => {
    console.log('submit score clicked');
    const myHeaders = new Headers();
    fetch("https://www.jsausa.com/arcade/api/ticket/farmer", {
      method: "GET",
      headers: myHeaders
    })
      .then(response => response.json())
      .then(json => {
        console.log(json);
        let ticket = json.result;
        const data = {
          name: name,
          score: state.playground.score,
          ticket: ticket
        };
        fetch("https://www.jsausa.com/arcade/api/hiscore/farmer", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        })
          .then(response => response.json())
          .then(json => {
            dispatch({
              type: "SCORE_SUBMITTED"
            });
            console.log(json);
            fetch("https://www.jsausa.com/arcade/api/hiscore/farmer", {
              method: "GET",
              headers: myHeaders
            })
              .then(response => response.json())
              .then(json => {
                setScores(json.result);
              })
              .catch(err => {
                console.log(err);
              });
          })
          .catch(err => {
            console.log(err);
          });
      })
      .catch(err => {
        console.log(err);
      });
  };

  const closeScores = () => {
    dispatch({
      type: "CLOSE_SCORES"
    });
  };

  const namehandler = e => {
    setName(e.target.value);
  };

  // const wrapperRef = React.useRef(null);
  // useOutsideAlerter(wrapperRef);

  return (
    <div className="app">
      <h1 style={{ marginBottom: "5px" }}>Farmer Danielle!</h1>
      <img src={danielle} alt="Farmer Danielle" width="70px" />
      {window.innerWidth >= 400
        ? <div style={{ textAlign: "center" }}>
            <p style={directionStyle}>
              Help Farmer Danielle gather her turkeys for the big JSA
              Thanksgiving Feast!
            </p>
            <p style={directionStyle}>
              Be careful not to leave her property since it is turkey season!
            </p>
          </div>
        : null}
      {state.playground.isGameOver
        ? <div>
            <p style={directionStyle}>GAME OVER</p>{" "}
          </div>
        : null}
      <p style={directionStyle}>
        {" "}Score: {state.playground.score}
      </p>
      <div className="btn-group">
        <button onClick={reset} type="button">
          New Game
        </button>
        <button onClick={pause} type="button">
          Pause
        </button>
        <button id="myBtn" onClick={openScores}>
          High Scores
        </button>
      </div>

      <Swipeable
        onSwipedUp={onSwipeUp}
        onSwipedDown={onSwipeDown}
        onSwipedLeft={onSwipeLeft}
        onSwipedRight={onSwipeRight}
      >
        <Grid
          snake={state.snake}
          snack={state.snack}
          isGameOver={state.playground.isGameOver}
          isGameStopped={state.playground.isGamePaused}
        />
      </Swipeable>

      {window.innerWidth >= 400
        ? <div style={{ textAlign: "center" }}>
            <p style={directionStyle}>
              Use the arrow keys to move Danielle around the board
            </p>
            <p style={directionStyle}>Press the Spacebar to restart the game</p>
            <p style={directionStyle}>Press the Esc key to pause the game</p>
          </div>
        : <p style={directionStyle}>Swipe to move</p>}
      {state.playground.showScores
        ? <div
            // ref={wrapperRef}
            id="myModal"
            className="modal"
          >
            <div className="modal-content">
              <div className="modal-header">
                <span className="close" onClick={closeScores}>
                  &times;
                </span>
                <h2>High Scores!</h2>
              </div>
              <div className="modal-body">
                <table>
                  <tr>
                    <th>Rank</th>
                    <th>Name</th>
                    <th>Points</th>
                  </tr>

                  {scores.length === 0
                    ? "No Scores Yet!"
                    : scores.map((x, i) => {
                        if (i < 5) {
                          return (
                            <tr>
                              <td>
                                {i + 1}{" "}
                              </td>
                              <td>
                                {x.name}
                              </td>
                              <td>
                                {x.score}
                              </td>
                            </tr>
                          );
                        }
                      })}
                </table>
              </div>
              {state.playground.highScore
                ? <div
                    className="modal-footer"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <label>
                      Name:
                      <input
                        type="text"
                        id="id1"
                        name="whatever"
                        onChange={namehandler}
                        value={name}
                      />
                      <button type="button" onClick={submitScore}>
                        Submit!
                      </button>
                    </label>
                    {/* <h3>Add your score: </h3> <input type="text" id="fname" name="firstname" placeholder="Your name.."></input> */}
                  </div>
                : null}
            </div>
          </div>
        : null}
    </div>
  );
};

const Grid = ({ isGameOver, isGameStopped, snake, snack }) =>
  <div>
    {GRID.map(y =>
      <Row
        y={y}
        key={y}
        snake={snake}
        snack={snack}
        isGameOver={isGameOver}
        isGameStopped={isGameStopped}
      />
    )}
  </div>;

const Row = ({ isGameOver, isGameStopped, snake, snack, y }) =>
  <div className="grid-row">
    {GRID.map(x =>
      <Cell
        x={x}
        y={y}
        key={x}
        snake={snake}
        snack={snack}
        isGameOver={isGameOver}
        isGameStopped={isGameStopped}
      />
    )}
  </div>;

const Cell = ({ isGameOver, isGameStopped, snake, snack, x, y }) =>
  <div className={getCellCs(isGameOver, snake, snack, x, y, isGameStopped)} />;

export default App;
